module.exports = __webpack_public_path__ + "img/exhibitor.b319472b.png";